import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=8eb55c16&scoped=true&"
import script from "./TextEditor.vue?vue&type=script&lang=js&"
export * from "./TextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb55c16",
  null
  
)

export default component.exports